import * as React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { Box, Button } from '@mui/material'
import Translations from 'src/@core/layouts/components/Translations'
import { numberFormatAsked } from 'src/@core/utils/number-format-asked'
import { useRouter } from 'next/router'

interface Props {
  carbonFootprintEv: number
  carbonFootprintHa: number
  emission: number
  carbonSequestration: number
  landId: number
  cycle: string
}

const pillTextSx = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: '15px',
  backgroundColor: 'rgba(25, 118, 210, 0.20)',
  mt: '24px',
  height: '40px',
  paddingLeft: '20px',
  paddingRight: '20px'
}

export default function CarbonfootprintCard({ carbonFootprintEv, carbonFootprintHa, emission, carbonSequestration, landId, cycle }: Props) {
  const router = useRouter()

  return (
    <Card
      className='rodeos-card'
      sx={{
        minWidth: '250px',
        height: '495px',
        alignItems: 'center',
        borderRadius: '20px',
        backgroundColor: 'white !important',
      }}
    >
      <CardContent
        className='card-medio'
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}
        >
          <Typography
            sx={{ fontSize: '18px', fontWeight: '700', color: 'black', textAlign: 'center' }}
            className='cards-title'
          >
            <Translations text={'Carbon footprint'} />
          </Typography>
          <Typography
            sx={{
              color: '#222',
              textAlign: 'center',
              fontSize: '14px',
              fontWeight: 400,
              letterSpacing: '-0.28px',
              mb: '24px'
            }}
          >
            {cycle.replace('_', '/')}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              width: '100%',
              textAlign: 'center',
              mb: '30px',
              padding: '10px'
            }}
          >
            <Typography sx={{ color: 'black', fontWeight: '700', fontSize: '40px', pr: 2 }}>
              {numberFormatAsked(carbonFootprintEv)}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center' }}>
              <Typography sx={{ color: 'black', fontWeight: '500', fontSize: '18px', pr: 2 }}>
                <Translations text={'kgCO2eq/kg'} />
              </Typography>
              <Typography sx={{ color: 'black', fontWeight: '700', fontSize: '12px', pr: 2 }}>
                <Translations text={'PV produced'} />
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={pillTextSx}
        >
          <Typography sx={{ color: 'black', fontSize: 'clamp(10px, 14px, 18px)', textAlign: 'left', ml: 3 }}>
            <Translations text={'Footprint [KgCO2eq/ha]'} />
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row'
            }}
          >
            <Typography sx={{ color: 'black', fontWeight: '600', fontSize: '18px' }}>
              {numberFormatAsked(carbonFootprintHa)}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={pillTextSx}
        >
          <Typography sx={{ color: 'black', fontSize: 'clamp(10px, 14px, 18px)', textAlign: 'left', ml: 3 }}>
            <Translations text={'Emission [KgCO2e/ha]'} />
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row'
            }}
          >
            {
              <Typography sx={{ color: 'black', fontWeight: '600', fontSize: '18px' }}>
                {numberFormatAsked(emission)}
              </Typography>
            }
          </Box>
        </Box>

        <Box
          sx={pillTextSx}
        >
          <Typography sx={{ color: 'black', fontSize: 'clamp(10px, 14px, 18px)', textAlign: 'left', ml: 3 }}>
            <Translations text={'Sequestration [KgCO2e/ha]'} />
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row'
            }}
          >
            <Typography sx={{ color: 'black', fontWeight: '600', fontSize: '18px' }}>
              {numberFormatAsked(carbonSequestration)}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center', w: '100%', alignItems: 'center', mt: 'auto' }}>
          <Button
            variant='outlined'
            sx={{
              color: '#213D36',
              width: '123px',
              padding: '8px, 12px, 8px, 12px',
              fontSize: '16px',
              fontWeight: 700,
              borderRadius: '30px',
              border: '3px solid #213D36',
              mt: 'auto'
            }}
            onClick={() => router.push(`/lands/details/land/${landId}`)}
          >
            <Translations text={'See more'} />
          </Button>
        </Box>
      </CardContent>
    </Card>
  )
}
